export type ExamQuestion = {
    id: number;
    text: string;
    author: string;
    type: ExamQuestionType;
}

export enum ExamQuestionType {
    SingleChoice = '766d7fba-d71d-4ef7-a975-5604aa4427b1',
    MultipleChoices = '8eeb0876-9b75-4ad7-b46c-7502df7e054f',
    ShortAnswer = '990c7fbc-26ec-4ceb-9a43-dffaa9564c58',
    CorrectIncorrect = '8005fc19-b4a7-4f15-abe2-59208d5f0baf',
    EssayQuestion = 'a90281c7-f5bd-4af0-8255-791cc0f4ff41',
    Connecting = '15175df6-3f9e-48e4-9190-08d9826cd1f8',
    ImageChoice = '7187fd51-8a8a-4e54-a9ae-a247f77e01db',
    ImageMultipleChoice = '2787fd51-8a8a-4e54-a9ae-a247f87e01db'
}